/**
 * 优化测试页面
 */
import { useState, useRef } from 'react';
import { Button, Switch } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import CategoryTreeSelect from '@/components/categoryTreeSelect';
import styles from './index.module.scss';
import CategoryTreeSelectV2 from '@/components/categoryTreeSelectV2';
import CarTree from '@/components/carTree';
import CarTreeV2, { CarTreeV2Ref } from '@/components/carTreeV2';

const OptimizeTestingPage = () => {
    const [visible1, setVisible1] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [visible3, setVisible3] = useState(false);
    const [visible4, setVisible4] = useState(false);

    // CarTreeV2 的 ref
    const carTreeV2Ref = useRef<CarTreeV2Ref>(null);

    // 测试过滤方法
    const handleTestFilter = async () => {
        if (carTreeV2Ref.current) {
            const filteredKeys = await carTreeV2Ref.current.getFilteredSelectedNodes();
            console.log('=== CarTreeV2 过滤测试结果 ===');
            console.log('过滤后的选中节点:', filteredKeys);
            console.log('节点数量:', filteredKeys.length);


        } else {
            console.warn('CarTreeV2 组件未加载或 ref 未绑定');

        }
    };

    // 处理过滤后的选中节点变化
    const handleFilteredSelectionChange = (filteredKeys: React.Key[]) => {
        console.log('过滤后的选中节点变化:', filteredKeys);
    };

    return <div className={styles.container}>


        {/* 测试分类选择 */}
        <div className={styles.box}>
            <div>
                <Switch
                    checked={visible1}
                    onChange={setVisible1}
                    checkedChildren="显示"
                    unCheckedChildren="隐藏"
                />
                <h2 style={{ margin: '10px 0' }}>CategoryTreeSelect</h2>
                {visible1 && <CategoryTreeSelect treeCheckable />}
            </div>
            <div  >
                <Switch
                    checked={visible2}
                    onChange={setVisible2}
                    checkedChildren="显示"
                    unCheckedChildren="隐藏"
                />
                <h2 style={{ margin: '10px 0' }}>CategoryTreeSelectV2</h2>
                {visible2 && <CategoryTreeSelectV2 treeCheckable />}
            </div>

            <div>
                <Switch
                    checked={visible3}
                    onChange={setVisible3}
                    checkedChildren="显示"
                    unCheckedChildren="隐藏"
                />
                <h2 style={{ margin: '10px 0' }}>CarTree</h2>
                {visible3 && (
                    <CarTree
                        checkable
                        treeCheck={(e) => { console.log('选中的车辆ID：', e); }}
                        defaultFilterKey="hasJtDevice"
                    />
                )}
            </div>
            <div  >
                <Switch
                    checked={visible4}
                    onChange={setVisible4}
                    checkedChildren="显示"
                    unCheckedChildren="隐藏"
                />
                <h2 style={{ margin: '10px 0' }}>CarTreeV2</h2>
                {visible4 && (
                    <>
                        <CarTreeV2
                            ref={carTreeV2Ref}
                            checkable
                            onFilteredSelectionChange={handleFilteredSelectionChange}
                        />
                        <Button
                            type="primary"
                            onClick={handleTestFilter}
                            disabled={!visible4}
                            style={{ marginRight: '12px' }}
                        >
                            测试过滤功能
                        </Button>
                    </>

                )}

            </div>
        </div>



    </div>
}

export default OptimizeTestingPage;